import React, { Component } from 'react'
import { Grid } from '@material-ui/core'
import withWidth, { isWidthUp } from '@material-ui/core/withWidth'
import SectionTitle from './SectionTitle'
import { withStyles } from '@material-ui/core/styles'
import useStyles from './styles/SectionContainerStyle'
import SectionCarousel from './Carousel/SectionCarousel'
import SectionHorizontalList from './Horizontal/SectionHorizontalList'
import SectionThreeItems from './ThreeItems/SectionThreeItems'
import CarouselSectionForSmall from './Carousel/CarouselForSmall/CarouselSectionForSmall'

export const SectionType = {
  carousel: 'carousel',
  horizontalList: 'horizontalList',
  threeItems: 'threeItems',
}

class SectionContainer extends Component {

  renderSectionComponent = () => {
    const playlist = this.props.playlist
    switch (this.props.type) {
      case SectionType.carousel:
        if (isWidthUp('md', this.props.width)){
          return <SectionCarousel
                    playlist={playlist}
                    onVideoClicked={(videoIndex) => this.props.onVideoClicked(videoIndex)}
                  />
        } else { // if screen size is small:
          return <CarouselSectionForSmall
                    playlist={playlist}
                    onVideoClicked={(videoIndex) => this.props.onVideoClicked(videoIndex)}
                  />
        }
      case SectionType.horizontalList:
        return <SectionHorizontalList
                  playlist={playlist}
                  onVideoClicked={(videoIndex) => this.props.onVideoClicked(videoIndex)}
                />
      case SectionType.threeItems:
        return <SectionThreeItems
                  playlist={playlist}
                  onVideoClicked={(videoIndex) => this.props.onVideoClicked(videoIndex)}
                />
      default:
        return null;
    }
  }

  render() {
    const classes = this.props.classes
    return (
      <Grid container className={classes.root}>
        <Grid item className={classes.title}>
          <SectionTitle title={this.props.name} />
        </Grid>
        <Grid
          container
          direction="column"
          justify="center"
          alignItems="center"
          className={`${classes.sectionContainer} section-container`}
        >
          {this.renderSectionComponent()}
        </Grid>
      </Grid>
    )
  }
}
export default withStyles(useStyles)(withWidth()(SectionContainer))
